import React from "react";

export default function DeleteIcon({ color = "currentColor" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8922 4.81776H11.5708C11.7476 4.81776 11.8922 4.67312 11.8922 4.49634V4.81776H24.1065V4.49634C24.1065 4.67312 24.2512 4.81776 24.4279 4.81776H24.1065V7.71062H26.9994V4.49634C26.9994 3.07803 25.8463 1.92491 24.4279 1.92491H11.5708C10.1525 1.92491 8.99937 3.07803 8.99937 4.49634V7.71062H11.8922V4.81776ZM32.1422 7.71062H3.85652C3.14535 7.71062 2.5708 8.28518 2.5708 8.99634V10.2821C2.5708 10.4588 2.71544 10.6035 2.89223 10.6035H5.31902L6.31143 31.6169C6.37571 32.987 7.50875 34.0678 8.87884 34.0678H27.1199C28.494 34.0678 29.623 32.991 29.6873 31.6169L30.6797 10.6035H33.1065C33.2833 10.6035 33.4279 10.4588 33.4279 10.2821V8.99634C33.4279 8.28518 32.8534 7.71062 32.1422 7.71062ZM26.8105 31.1749H9.18821L8.21589 10.6035H27.7829L26.8105 31.1749Z"
        fill={!!color ? color : "black"}
        fillOpacity="0.85"
      />
    </svg>
  );
}
